<form #formRef="ngForm" [class.preview-active]="preview" [class.has-embedcode]="entity && outstream && !isNew" [class.is-new]="isNew">
	<bb-page-header [backOnMobile]="['/adservices/adunits']" [tabItems]="tabItems" [icon]="'caret-square-right'" [title]="adunit?.title">

		<span class="subtitle"> {{ adunit?.code }} </span>

		<bb-status *ngIf="adunit" [(ngModel)]="adunit.status" name="status" [labelOn]="'ENABLED' | translate"
			[labelOff]="'DISABLED' | translate"></bb-status>

	</bb-page-header>

	<bb-adstats-blocks *ngIf="!isNew" [adunitCode]="adunit?.code" [statsDate]="statsDate"></bb-adstats-blocks>

	<div class="body-columns-container">
		<div class="body-column tab-container" cdkScrollable>
			<p *ngIf="adBlocker" class="warning message"><i class="fa fa-warning"></i> {{ 'ADS_ARE_DISABLED' | translate }}</p>
			<adunit-details-general *ngIf="adunit && tabLoadedBefore('general')" [form]="form" [formGroup]="formGroup" [adunit]="entity" [lineitem]="lineitem" [isNew]="isNew" [hidden]="activeTab !== 'general'"></adunit-details-general>
			<adunit-details-prebid *ngIf="adunit && tabLoadedBefore('prebid')" [form]="form" [adunit]="entity" [hidden]="activeTab !== 'prebid'"></adunit-details-prebid>
		</div>

		<div *ngIf="adunit?.positionType !== 'vmap'" class="body-column preview-container">
			<bb-date-presets
				(onChanged)="datesChanged($event)"
				[icon]="'line-chart'"
				[presets]="adServicesService.datePresets"
				[time]="true">
			</bb-date-presets>

			<div class="adunit-container">
				<h3>{{ 'ASSIGNED_ITEMS' | translate }}</h3>
				<div class="selectors">
					<a class="button" (click)="createNewLineitem()"><i class="fa fa-plus"></i><span>{{ 'CREATE_NEW_LINE_ITEM' | translate }}</span></a>
					<bb-entity-selector [excludedOptions]="adunit?.assignedLineitems" [placeholder]="placeholder" [icon]="'chain'" [entityType]="'lineitem'" [ngModel]="assignedLineitems" (ngModelChange)="lineitemSelected($event)" [filterSet]="lineitemFilterSet" [ngModelOptions]="{standalone: true}"></bb-entity-selector>
				</div>

				<bb-table-container cdkDropList (cdkDropListDropped)="lineitemDragged($event)">

					<bb-table-header [configurable]="false">
						<bb-table-header-cell [hideSorting]="true" property="id"></bb-table-header-cell>
						<bb-table-header-cell [hideSorting]="true" property="id"></bb-table-header-cell>
						<bb-table-header-cell [hideSorting]="true" property="title" class="overflow">{{ 'TITLE' | translate }}</bb-table-header-cell>
						<bb-table-header-cell [hideSorting]="true" property="inventory">{{ 'INVENTORY' | translate }}</bb-table-header-cell>
						<bb-table-header-cell [hideSorting]="true" property="views">{{ 'IMPRESSIONS' | translate }}</bb-table-header-cell>
						<bb-table-header-cell [hideSorting]="true" property="fillRate">{{ 'FILL_RATE' | translate }}</bb-table-header-cell>
						<bb-table-header-cell [hideSorting]="true" property="clickthroughRate">{{ 'CTR' | translate }}</bb-table-header-cell>
						<bb-table-header-cell [hideSorting]="true" property="status" class="icon">&nbsp;</bb-table-header-cell>
						<bb-table-header-cell class="buttons"></bb-table-header-cell>
					</bb-table-header>
			
					<ng-container *ngFor="let row of rows; let i = index;">
						<bb-table-row cdkDrag cdkDragLockAxis="y" *ngIf="!row.deleted" [row]="row" [colspan]="10" class="adunit-details-lineitem-quickedit">
							<bb-table-cell cdkDragHandle property="id"><span class="fa fa-bars"></span></bb-table-cell>
							<bb-table-cell cdkDragHandle property="id"><span>{{ i + 1 }}.</span></bb-table-cell>
							<bb-table-cell cdkDragHandle property="title" class="overflow">
								<span [attr.title]="row?.data?.title + (row?.data?.subtype ? ' (' + ( row?.data?.subtype | uppercase | translate ) + ')' : '')" [innerHTML]="row?.data?.title"></span>
								<strong *ngIf="row?.data?.subtype"> ({{ row?.data?.subtype | uppercase | translate }})</strong>
							</bb-table-cell>
							<bb-table-cell cdkDragHandle property="inventory"><span innerHTML="{{ lineitemStats[row?.id]?.inits | number }}"></span></bb-table-cell>
							<bb-table-cell cdkDragHandle property="views"><span innerHTML="{{ lineitemStats[row?.id]?.views | number }}"></span></bb-table-cell>
							<bb-table-cell cdkDragHandle property="fillRate"><span innerHTML="{{ lineitemStats[row?.id]?.fillrate | number }}%"></span></bb-table-cell>
							<bb-table-cell cdkDragHandle property="clickthroughRate"><span innerHTML="{{ lineitemStats[row?.id]?.clickrate | number }}%"></span></bb-table-cell>
							<bb-table-cell cdkDragHandle property="status"><span [innerHTML]="row.data | statusIcon"></span></bb-table-cell>
							<bb-table-cell cdkDragHandle class="buttons">
				
								<a class="button" (click)="onItemRemoved(i)">
									<i class="fa fa-chain-broken"></i>
								</a><!--
				
								--><a class="button" [ngClass]="{'disabled': !row?.id}" (click)="goToLineitem(row)">
									<i class="fa fa-edit"></i>
								</a><!--
				
								--><a class="button" [ngClass]="{'disabled': !row?.id || row?.data?.subtype === 'auction'}" (click)="row.quickEditing = !row.quickEditing">
									<i class="fa fa-pencil"></i>
								</a>
				
							</bb-table-cell>
							<div quickedit>
								<lineitem-quickedit *ngIf="row?.quickEditing" [parentForm]="form" [row]="row" (rowChange)="rowChanged(i, $event)"
									(canceled)="onItemRemoved(i)" (unlinked)="onItemRemoved(i)" [index]="i" [unlink]="true" [noQuickeditService]="true">
								</lineitem-quickedit>
							</div>
						</bb-table-row>
					</ng-container> 
			
				</bb-table-container>
			
				<bb-table-pager></bb-table-pager>
			
				<div class="no-results" *ngIf="!rows || !rows.length">{{ 'ADUNIT_NO_LINE_ITEMS_ATTACHED' | translate }}</div>

				<div class="adunit-actions">
					<span class="button" [ngClass]="{'active': preview}" (click)="preview = !preview"><i class="fa fa-arrows-h"></i>{{ 'EXPAND' | translate }}</span>
				</div>
		
			</div>
			
			<bb-entity-details
				[entity]="entity"
			></bb-entity-details>
		</div>
	</div>
</form>

<bb-embed-bar *ngIf="entity && outstream" idProp="code" embedPath="a" [entity]="entity" extraPreviewParameters="?placementOption=default&noStats=true&width=800"></bb-embed-bar>

<bb-actions-bar (onSave)="save()" (onCancel)="cancel()" (onDelete)="delete()" [form]="form"
	[entity]="entity">
</bb-actions-bar>
